module.exports = __webpack_public_path__ + "img/TETHER.6606950a.svg";